import { OrcamentoIcon } from './OrcamentoUI';
import { useLiquidFeedback, LiquidDialog } from './LiquidUI';
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './CardManagerModal.css'; // Reusing CardManager styles for consistency

const EmpresasManagerModal = ({ onClose, onEmpresasChange }) => {
    const liquidFeedback = useLiquidFeedback();
    const [empresas, setEmpresas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [nome, setNome] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchEmpresas();
    }, []);

    const fetchEmpresas = async () => {
        try {
            const res = await api.get('/veiculos/empresas/list');
            setEmpresas(res.data);
            if (onEmpresasChange) onEmpresasChange();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            if (editingId) {
                // Update existing empresa
                await api.put(`/veiculos/empresas/${editingId}`, { nome });
            } else {
                // Create new empresa
                await api.post('/veiculos/empresas', { nome });
            }
            setNome('');
            setEditingId(null);
            fetchEmpresas();
        } catch (err) {
            console.error(err);
            const status = err.response?.status || 'N/A';
            const msg = err.response?.data?.error || err.message || 'Erro desconhecido';
            liquidFeedback.notify(`Erro (${status}): ${msg}`);
        } finally {
            setSubmitting(false);
        }
    };

    const handleEdit = (empresa) => {
        setNome(empresa.nome);
        setEditingId(empresa.id);
    };

    const handleCancelEdit = () => {
        setNome('');
        setEditingId(null);
    };

    return (
        <LiquidDialog onClose={onClose} className="card-manager-overlay" onClick={onClose}>
            <div className="card-manager-modal" onClick={e => e.stopPropagation()}>
                <div className="card-manager-header">
                    <h2><OrcamentoIcon name="building" fallback="🏢" /> Gerir Empresas</h2>
                    <button className="close-btn" onClick={onClose} aria-label="Fechar"><OrcamentoIcon name="close" fallback="×" /></button>
                </div>

                <form className="card-form" onSubmit={handleSubmit}>
                    <h4>{editingId ? '✏️ Editar Empresa' : 'Nova Empresa'}</h4>
                    <div className="form-row">
                        <div className="form-group" style={{ flex: 1 }}>
                            <label>Nome da Empresa</label>
                            <input
                                type="text"
                                value={nome}
                                onChange={e => setNome(e.target.value)}
                                placeholder="Ex: Cliente A"
                                required
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn-save" disabled={submitting}>
                            {editingId ? 'Guardar Alterações' : 'Adicionar Empresa'}
                        </button>
                        {editingId && (
                            <button type="button" className="btn-cancel" onClick={handleCancelEdit}>
                                Cancelar
                            </button>
                        )}
                    </div>
                </form>

                <div className="cards-list">
                    {loading ? <p>A carregar...</p> : empresas.map(emp => (
                        <div key={emp.id} className="card-item">
                            <div className="card-info">
                                <h5>{emp.nome}</h5>
                            </div>
                            <div className="card-actions">
                                <button
                                    className="btn-icon-edit"
                                    onClick={() => handleEdit(emp)}
                                    title="Editar empresa"
                                >
                                    <OrcamentoIcon name="edit" fallback="✏️" />
                                </button>
                            </div>
                        </div>
                    ))}
                    {!loading && empresas.length === 0 && (
                        <p style={{ textAlign: 'center', color: '#718096' }}>Nenhuma empresa registada.</p>
                    )}
                </div>
            </div>
        </LiquidDialog>
    );
};

export default EmpresasManagerModal;
